import { render, staticRenderFns } from "./PromptRestore.vue?vue&type=template&id=dbacf86a&scoped=true&"
import script from "./PromptRestore.vue?vue&type=script&lang=js&"
export * from "./PromptRestore.vue?vue&type=script&lang=js&"
import style0 from "./PromptRestore.vue?vue&type=style&index=0&id=dbacf86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbacf86a",
  null
  
)

export default component.exports